require('./layout.css');
require('./photoSwipeSource/photoswipe.css');
require('./photoSwipeSource/default-skin.css');
const PhotoSwipe = require('./photoSwipeSource/photoswipe.min.js');
const PhotoSwiprUIDefault = require('./photoSwipeSource/photoswipe-ui-default.min.js');
const layout = require('./layout.ejs');

const LivePhotoSwipe = function(options) {
    this.init(options);
};

LivePhotoSwipe.prototype.init = function(options) {
    this.pictures = this.cleanPics(options.pictures || []);
    this.currentOrder = options.index || 0;
    this.container = null;
    this.gullery = null;
    this.initComponent();
    this.showSwipe();
    this.handleDomEvent();
};

LivePhotoSwipe.prototype.cleanPics = function(pictures) {
    const cleanPicsA = [];

    for (let i = 0; i < pictures.length; i++) {
        let bigShowPic = pictures[i].url;
        if (bigShowPic.includes('d.ifengimg.com/')) {
            bigShowPic = bigShowPic.split('d.ifengimg.com/').pop();
            const paths = bigShowPic.split('/');
            paths.shift();
            bigShowPic = paths.join('/');
        }

        if (bigShowPic.includes('http://')) {
            bigShowPic = bigShowPic.substring(7);
        }

        if (bigShowPic.includes('https://')) {
            bigShowPic = bigShowPic.substring(8);
        }

        if (bigShowPic.includes('//')) {
            bigShowPic = bigShowPic.substring(2);
        }

        cleanPicsA.push({
            src: 'https://' + bigShowPic,
            w: Number(pictures[i].w || 0),
            h: Number(pictures[i].h || 0)
        });
    }

    return cleanPicsA;
};

LivePhotoSwipe.prototype.initComponent = function() {
    this.container = $(layout({ current: this.currentOrder + 1, totalPage: this.pictures.length }));
    $('body').append(this.container);
};

LivePhotoSwipe.prototype.showSwipe = function() {
    const gulleryConfig = {
        index: this.currentOrder,
        bgOpacity: 1,
        spacing: 0.06,
        loop: false,
        history: false,
        pinchToClose: false,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        closeEl: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        tapToClose: true,
        tapToToggleControls: false,
        clickToCloseNonZoomable: false,
        isClickableElement: function(el) {
            return el.tagName === 'IMG';
        }
    };
    this.gullery = new PhotoSwipe(this.container[0], PhotoSwiprUIDefault, this.pictures, gulleryConfig);
    this.gullery.init();
};

LivePhotoSwipe.prototype.handleDomEvent = function() {
    $('.photo_closeBtn').on('click', $.proxy(this.hide, this));
    this.gullery.listen('afterChange', () => {
        this.currentOrder = this.gullery.getCurrentIndex();
        $('.photo_current').text(this.currentOrder + 1);
    });
    this.gullery.listen('close', $.proxy(this.hide, this));
};

LivePhotoSwipe.prototype.hide = function() {
    this.container.remove();
};

module.exports = LivePhotoSwipe;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.pic.mobile/app/modules/photoSwipe/index.js